import {takeLatestF} from '@fl/cmsch-fe-library';
import {isEmpty} from 'lodash/fp';
import {SagaIterator} from 'redux-saga';
import {put, select} from 'typed-redux-saga';

import {Config} from 'app/config';
import {formHelpers} from 'utils/forms';

import {exportPdfFormName} from '../../types/export-pdf-form-values';
import {animalBrowserAction, SubmitPrintModalAction} from '../action';
import {simpleAnimalBrowserSelector} from '../selector';

const getEnvironment = (): string => {
    if (Config.environment === 'development') {
        return '-pretest';
    } else if (Config.environment === 'staging') {
        return '-test';
    } else {
        return '';
    }
};

function* execute(action: SubmitPrintModalAction): SagaIterator {
    const femalesForExport = yield* select(simpleAnimalBrowserSelector.femalesForExport);
    const bullsForExport = yield* select(simpleAnimalBrowserSelector.bullsForExport);
    const formValues = yield* select(formHelpers.formValues(exportPdfFormName));
    const sex = action.payload;

    const uz = '/uz/';
    if (!isEmpty(femalesForExport) && sex === 'FEMALE') {
        const baseUrl = `https://doklady${getEnvironment()}.eskot.cz/inseminacni-karta/pdf/tpl/`;
        const earTags = femalesForExport.join(',');
        const documentType = formValues.prop('breederFemaleDocuments').orCrash('Female document type is required');
        const url = `${baseUrl}${documentType}${uz}${earTags}`;
        window.open(url, '_blank');
        yield* put(animalBrowserAction.setFemalesForExport([]));
    }

    if (!isEmpty(bullsForExport) && sex === 'MALE') {
        const baseUrl = `https://doklady${getEnvironment()}.eskot.cz/karta-byka/pdf/tpl/`;
        const earTags = bullsForExport.join(',');
        const documentType = formValues.prop('bullsDocument').orCrash('Bull document type is required');
        const url = `${baseUrl}${documentType}${uz}${earTags}`;
        window.open(url, '_blank');
        yield* put(animalBrowserAction.setBullsForExport([]));
    }
}

/**
 * Submits the print modal and opens the generated document URL.
 *
 * @returns The saga watcher for `SUBMIT_PRINT_MODAL`.
 */
export function* submitPrintModalSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/SUBMIT_PRINT_MODAL', execute);
}
